package com.vamvisions.main.contact.presentation

import com.vamvisions.main.contact.domain.model.ContactTopic

sealed interface ContactAction {
    data class NameChanged(val value: String) : ContactAction
    data class EmailChanged(val value: String) : ContactAction
    data class MessageChanged(val value: String) : ContactAction
    /** Selects [topic], or clears it when it is already selected. */
    data class TopicClicked(val topic: ContactTopic) : ContactAction
    data class WebsiteChanged(val value: String) : ContactAction
    data object Send : ContactAction
}
